module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/dd43ac3ce65e4e3d247182afa62b523f.png";